import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import parsePostContent from '../../common/helpers/parsePostContent';
/**
 * System post for "battle finished from the admin panel". Type:
 * arenaBattleAdminClosed. No subtitle by design — see the PHP post class's
 * docblock — reuses the same win/draw title copy as the in-battle outcome
 * (battle_turn.win_title / battle_turn.draw_title) rather than duplicating
 * the strings under a new key.
 */
export default class ArenaBattleAdminClosedPost extends Component {
  view() {
    const data = parsePostContent(this.attrs.post.content());
    if (!data) return null;
    const isDraw = data.outcome === 'draw';
    return m("div", {
      className: `ArenaFinalPost ArenaFinalPost--${isDraw ? 'draw' : 'win'} EventPost`
    }, m("div", {
      className: "ArenaFinalPost-icon"
    }, m("i", {
      className: isDraw ? 'fas fa-handshake' : 'fas fa-trophy'
    })), m("div", {
      className: "ArenaFinalPost-body"
    }, m("div", {
      className: "ArenaFinalPost-title"
    }, isDraw ? app.translator.trans('forumaker-arena.forum.battle_turn.draw_title') : app.translator.trans('forumaker-arena.forum.battle_turn.win_title', {
      name: m("strong", null, data.winnerName ?? '')
    }))));
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/ArenaBattleAdminClosedPost', ArenaBattleAdminClosedPost);